// extracted by mini-css-extract-plugin
export default {"container":"Dienst_container__isJbw","content":"Dienst_content__H5wWX","text":"Dienst_text__wShPX"};